export function getPlannerVersion(): string {
  const versionMatch = document.location.href.match(/\/(\d+\.\d+\.\d+\.\d+)\//);
  return versionMatch ? versionMatch[1] : '0.1';
}
